function topic_covid19(covidDeafultKey, covidDeafultStart, covidDeafultEnd){
	var specialSeeProjectList = ajax_call(publicPath + '/napi/emis/project?query_condition=特殊查看'),
		defalutProjectSelectedOption = "",
		newestDate = ajax_call(publicPath + '/napi/emis/covid_newest_date?project_id=' + covidDeafultKey)
	specialSeeProjectList.forEach(el => {
		var thisPrjId = String(el.PRJ_ID)
		if (thisPrjId === covidDeafultKey) {
			defalutProjectSelectedOption += `<option value="${thisPrjId}" selected>${el.PRJ_NAME}</option>`	
		} else {
			defalutProjectSelectedOption += `<option value="${thisPrjId}">${el.PRJ_NAME}</option>`	
		}
	})
	// 篩選日期處理
	var newestDateParam = {
		confirmed: {
			start: get_time_string(6 * 24).split(" ")[0].replaceAll("-", "") + "000000",
			end: get_time_string(0).split(" ")[0].replaceAll("-", "") + "000000"
		},
		infection: {
			start: get_time_string(6 * 24).split(" ")[0].replaceAll("-", ""),
			end: get_time_string(0).split(" ")[0].replaceAll("-", "")
		}
	}
	console.log(newestDateParam)
	if (covidDeafultStart && covidDeafultEnd) {
		newestDateParam.confirmed.start = covidDeafultStart.replaceAll("-", "") + "000000"
		newestDateParam.confirmed.end = covidDeafultEnd.replaceAll("-", "") + "000000"
		newestDateParam.infection.start = covidDeafultStart.replaceAll("-", "")
		newestDateParam.infection.end = covidDeafultEnd.replaceAll("-", "")
	}
	console.log(newestDateParam)
	// 
	$("#legend_div_container").append('<div class="mb-1 legend_text" id="legend_tag_疫情點位"> 確診點位(時間遠近)<br> <img src="marker_icon/covid_circle.png" width="32"> </div><div class="mb-1 legend_text" id="legend_tag_足跡點位"> 足跡點位<br> <img src="marker_icon/covid_triangle.png" width="32"> </div> <div class="mb-1 legend_text" id="legend_tag_疫調點位"> 疫調點位<br> <img src="marker_icon/covid_square.png" width="26"> </div> <div class="mb-1 legend_text" id="legend_tag_疫調點位(解除列管)"> 疫調點位(解除列管)<br> <img src="marker_icon/covid_square_g.png" width="26"> </div> <div class="mb-1 legend_text" id="legend_tag_居家照護點位"> 居家照護點位<br> <img src="marker_icon/covid_isolation.png" width="32"> </div>');
	var heatMapParameterSetting = {},
		covidOverlayMapList = {
			'確診者點位圖X': {
				defaultStatus: 'close',
				additionHtml: `
					<div class="input-group-prepend">
						<label class="input-group-text">樣式</label>
					</div>
					<select id="covid-map-style" map-type="confirmed" class="custom-select"> 
						<option value="normal" selected>點位圖</option>
						<option value="cluster">群聚地圖</option>
					</select>`,
				action: function(){
					return overlay_dataset["確診者點位圖X"]
				}
			},
			'確診者足跡點位圖Y': {
				defaultStatus: 'close',
				additionHtml: `
					<div class="input-group-prepend">
						<label class="input-group-text">樣式</label>
					</div>
					<select id="covid-map-style-track" map-type="track" class="custom-select"> 
						<option value="normal" selected>點位圖</option>
						<option value="cluster">群聚地圖</option>
					</select>`,
				action: function(){
					return overlay_dataset["確診者足跡點位圖Y"]
				}
			},
			'疫調點位圖': {
				defaultStatus: 'close',
				additionHtml: `
					<div class="input-group-prepend">
						<label class="input-group-text">樣式</label>
					</div>
					<select id="covid-map-style-infection" map-type="infection" class="custom-select"> 
						<option value="normal" selected>點位圖</option>
						<option value="cluster">群聚地圖(無法區別控管顏色)</option>
					</select>`,
				action: function(){
					return overlay_dataset["疫調點位圖"]
				}
			},
			'居家照護點位圖': {
				defaultStatus: 'close',
				additionHtml: `
					<div class="input-group-prepend">
						<label class="input-group-text">樣式</label>
					</div>
					<select id="covid-map-style-isolation" map-type="isolation" class="custom-select"> 
						<option value="normal" selected>點位圖</option>
						<option value="cluster">群聚地圖</option>
					</select>`,
				action: function(){
					return overlay_dataset["居家照護點位圖"]
				}
			},
			'NX+MY混和熱度圖': {
				defaultStatus: 'close',
				action: function(){
					if (!this.baseData) {
						this.baseData = geoJsonIsolation
					}
					var layerData = this.baseData,
						heatArray = {max: heatMapParameterSetting["max-weight"], data:[]},
						cfg = {
							radius: (heatMapParameterSetting["radius"] / 100000),
							maxOpacity: .9,
							scaleRadius: true,
							useLocalExtrema: false,
							latField: 'lat',
							lngField: 'lng',
							valueField: 'count'
						},
						covidPointLayer = L.geoJson(geoJson),
						trackPointLayer = L.geoJson(layerData)
					if (heatMapParameterSetting["covid-weight"] !== 0) {
						for (var element in covidPointLayer._layers) {
							var thisDateString = parseInt(String(covidPointLayer._layers[element].feature.properties.RPT_TIME).slice(0, 8))
							if (thisDateString >= parseInt(heatMapParameterSetting.start_time) && thisDateString <= parseInt(heatMapParameterSetting.end_time)) {
								heatArray.data.push({lat: parseFloat(covidPointLayer._layers[element].feature.geometry.coordinates[1]), lng: parseFloat(covidPointLayer._layers[element].feature.geometry.coordinates[0]), count: heatMapParameterSetting["covid-weight"]});
							}
						}
					}
					if (heatMapParameterSetting["track-weight"] !== 0) {
						for (var element in trackPointLayer._layers) {
							var thisDateString = parseInt(String(trackPointLayer._layers[element].feature.properties.RPT_TIME).slice(0, 8))
							if (thisDateString >= parseInt(heatMapParameterSetting.start_time) && thisDateString <= parseInt(heatMapParameterSetting.end_time)) {
								heatArray.data.push({lat: parseFloat(trackPointLayer._layers[element].feature.geometry.coordinates[1]), lng: parseFloat(trackPointLayer._layers[element].feature.geometry.coordinates[0]), count: heatMapParameterSetting["track-weight"]});
							}
						}
					}
					var trackHeatLayer = new HeatmapOverlay(cfg);
					trackHeatLayer.setData(heatArray);
					return trackHeatLayer
				}
			},
			'新北市次分區': {
				defaultStatus: 'close',
				action: function(){
					return overlayMaps["新北市次分區"]
				}
			},
			'新北市村里界': {
				defaultStatus: 'close',
				action: function(){
					return overlayMaps["新北市村里界"]
				}
			},
		},
		allCovidData = ajax_call(publicPath + '/napi/emis/event?project_id=' + covidDeafultKey + '&type=疫情&start=' + newestDateParam.confirmed.start + '&end=' + newestDateParam.confirmed.end)[0],
		infectionData = ajax_call(publicPath + '/napi/emis/covid_infection?start_time=' +  newestDateParam.infection.start + "&end_time=" +  newestDateParam.infection.end),
		mapStyleSetting = {
			confirmed: 'normal',
			track: 'normal',
			infection: 'normal',
			isolation: 'normal',
		},
		timePickSetting = {
			confirmed: undefined,
			track: undefined
		},
		chartParameter = {
			confirmed: {
				name: "確診點",
				div: "",
				keyName: "confirmed",
				colorPalette: {
					"7": "#74add1",
					"6": "#abd9e9",
					"5": "#e0f3f8",
					"4": "#ffffbf",
					"3": "#fee090",
					"2": "#fdae61",
					"1": "#f46d43",
					"0": "#d73027"
				},
				map: {
					layerName: "確診者點位圖X",
					color: "#e85a71",
					size: 7,
					clusterStyle: "red"
				},
				timeSeries: {
					chartTitle: "確診數統計長條圖",
					yAxisTitle: {
						up: "新增確診數",
						down: "累計確診數"
					},
					series: {
						up: "每日新增確診數",
						down: "累計至前日確診數"
					},
					color: "#e85a71"
				},
				townChart: {
					seriesName: "確診數",
					chartTitle: "各行政區確診數",
					color: "#e85a71",
					yAxisLabel: "例"
				},
				villChart: {
					seriesName: "確診數",
					color: "#e85a71",
					yAxisLabel: "例"
				}
			},
			track: {
				name: "足跡點",
				div: "-track",
				keyName: "track",
				map: {
					layerName: "確診者足跡點位圖Y",
					color: "grey",
					size: 5,
					clusterStyle: "grey"
				},
				timeSeries: {
					chartTitle: "足跡數統計長條圖",
					yAxisTitle: {
						up: "新增足跡數",
						down: "累計足跡數"
					},
					series: {
						up: "每日新增足跡數",
						down: "累計至前日足跡數"
					},
					color: "grey"
				},
				townChart: {
					seriesName: "足跡數",
					chartTitle: "各行政區足跡數",
					color: "grey",
					yAxisLabel: "數"
				},
				villChart: {
					seriesName: "足跡數",
					color: "grey",
					yAxisLabel: "數"
				}
			},
			infection: {
				name: "疫調點",
				div: "-infection",
				keyName: "infection",
				map: {
					layerName: "疫調點位圖",
					color: {
						solved: "limegreen",
						unsolved: "darkorchid"
					},
					size: 5,
					clusterStyle: "darkorchid"
				},
				timeSeries: {
					chartTitle: "疫調數統計長條圖",
					yAxisTitle: {
						up: "新增疫調數",
						down: "累計疫調數"
					},
					series: {
						up: "每日新增疫調數",
						down: "累計至前日疫調數"
					},
					color: "darkorchid"
				},
				townChart: {
					seriesName: "疫調數",
					chartTitle: "各行政區疫調數",
					color: "darkorchid",
					yAxisLabel: "數"
				},
				villChart: {
					seriesName: "疫調數",
					color: "darkorchid",
					yAxisLabel: "數"
				}
			},
			isolation: {
				name: "居家照護點",
				div: "-isolation",
				keyName: "isolation",
				map: {
					layerName: "居家照護點位圖",
					color: "#00AEF7",
					size: 5,
					clusterStyle: "blue"
				},
				timeSeries: {
					chartTitle: "居家照護數統計長條圖",
					yAxisTitle: {
						up: "新增居家照護數",
						down: "累計居家照護數"
					},
					series: {
						up: "每日新增居家照護數",
						down: "累計至前日居家照護數"
					},
					color: "#00AEF7"
				},
				townChart: {
					seriesName: "居家照護數",
					chartTitle: "各行政區居家照護數",
					color: "#00AEF7",
					yAxisLabel: "數"
				},
				villChart: {
					seriesName: "居家照護數",
					color: "#00AEF7",
					yAxisLabel: "數"
				}
			}
		},
		geoJson = turf.featureCollection([]), 
		allCovidTrackData = turf.featureCollection([]),
		geoJsonInfection = turf.featureCollection([]),
		geoJsonIsolation = turf.featureCollection([]),
		covidHtml = {
			projectList: `
				<div class="input-group input-group-sm mb-1">
					<div class="input-group-prepend">
						<label class="input-group-text">疫情專案選擇</label>
					</div>
					<select class="custom-select" id="covid-project-selector">
						${defalutProjectSelectedOption}
					</select>
				</div>
				<div class="input-group input-group-sm mb-1">
					<div class="input-group-prepend">
						<label class="input-group-text">時段選擇</label>
					</div>
					<input type="text" class="form-control date-picker" id="covid-project-start" value="${newestDateParam.confirmed.start.slice(0,4)}-${newestDateParam.confirmed.start.slice(4,6)}-${newestDateParam.confirmed.start.slice(6,8)}">
					<input type="text" class="form-control date-picker" id="covid-project-end" value="${newestDateParam.confirmed.end.slice(0,4)}-${newestDateParam.confirmed.end.slice(4,6)}-${newestDateParam.confirmed.end.slice(6,8)}">
				</div>
				<button type="button" class="btn btn-success btn-sm btn-block mb-2" id="covid-project-trig">套用設定</button>`,
			map: `
				<h5 class="font-weight-bold mb-1"><i class="fas fa-layer-group mr-2"></i>疫情相關套疊圖</h5>
				<div id="covid-overlaymap-container"></div>`,
			basic: `
				<h5 class="font-weight-bold mt-2"><i class="fas fa-clipboard mr-2"></i>確診數資訊</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						目前累計總確診數達
						<hr class="m-2">
						<h5 class="font-weight-bold m-0 text-danger" id="covid-total-number"></h5>
					</div>
				</div>
				<div class="w-100 h-350 mt-2" id="covid-timeseries-chart"></div>
				<p class="text-muted m-0">*註：您可點擊長條圖或是拖拉圖面進行時間選擇篩選</p>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-chart-bar mr-2"></i>區域確診數資訊<button id="covid-filter-reset-trig" map-type="confirmed" type="button" class="btn btn-sm float-right btn-secondary">重新篩選</button></h5>
				<div class="card shadow-sm" id="covid-time-range-total-number"></div>
				<div class="position-relative">
					<div class="w-100 h-300 mt-2" id="covid-town-chart"></div>
					<button type="button" class="btn btn-success btn-sm position-absolute" id="covid-alert-table-download-all" style="top: 0px; left: 0px;">表單下載</button>
				</div>
				<div class="w-100 d-none" id="covid-village-total-chart-container">
					<div class="position-relative">
						<div class="w-100 h-250" id="covid-village-total-chart"></div>
						<button type="button" class="btn btn-success btn-sm position-absolute" id="covid-alert-table-download-town" style="top: 0px; left: 0px;">表單下載</button>
					</div>
					<p class="text-muted m-0">*註：若顯示效果不佳，請調整側資訊區塊寬度</p>
				</div>`,
			track: `
				<h5 class="font-weight-bold mt-2"><i class="fas fa-clipboard mr-2"></i>足跡數資訊</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						目前累計總足跡數達
						<hr class="m-2">
						<h5 class="font-weight-bold m-0 text-danger" id="covid-total-number-track"></h5>
					</div>
				</div>
				<div class="w-100 h-350 mt-2" id="covid-timeseries-chart-track"></div>
				<p class="text-muted m-0">*註：您可點擊長條圖或是拖拉圖面進行時間選擇篩選</p>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-chart-bar mr-2"></i>區域足跡數資訊<button id="covid-filter-reset-trig-track" map-type="track" type="button" class="btn btn-sm float-right btn-secondary">重新篩選</button></h5>
				<div class="card shadow-sm" id="covid-time-range-total-number-track"></div>
				<div class="position-relative">
					<div class="w-100 h-300 mt-2" id="covid-town-chart-track"></div>
					<button type="button" class="btn btn-success btn-sm position-absolute" id="covid-alert-table-download-all-track" style="top: 0px; left: 0px;">表單下載</button>
				</div>
				<div class="w-100 d-none" id="covid-village-total-chart-container-track">
					<div class="position-relative">
						<div class="w-100 h-250" id="covid-village-total-chart-track"></div>
						<button type="button" class="btn btn-success btn-sm position-absolute" id="covid-alert-table-download-town-track" style="top: 0px; left: 0px;">表單下載</button>
					</div>
					<p class="text-muted m-0">*註：若顯示效果不佳，請調整側資訊區塊寬度</p>
				</div>`,
			alert: `
				<h5 class="font-weight-bold mb-1 mt-2"><i class="fas fa-fire mr-2"></i>熱度圖參數</h5>
				<label class="m-0">時段選擇</label>
				<div class="input-group input-group-sm mb-2">
					<input type="text" class="form-control date-picker covid-heart-map-trig" target="start_time" value="${newestDateParam.confirmed.start.slice(0,4)}-${newestDateParam.confirmed.start.slice(4,6)}-${newestDateParam.confirmed.start.slice(6,8)}">
					<input type="text" class="form-control date-picker covid-heart-map-trig" target="end_time" value="${newestDateParam.confirmed.end.slice(0,4)}-${newestDateParam.confirmed.end.slice(4,6)}-${newestDateParam.confirmed.end.slice(6,8)}">
				</div>
				<div class="row">
					<div class="col-6">
						<label class="m-0">確診點位權重N：<span class="covid-heart-map-value" target="covid-weight"></span></label>
						<div>
							<small class="m-0 text-muted float-left">0</span></small>
							<small class="m-0 text-muted float-right">10</small>
							<input type="range" class="custom-range covid-heart-map-trig" target="covid-weight" value="3" min="0" step="0.5" max="10">
						</div>
					</div>
					<div class="col-6">
						<label class="m-0">居家照護點位權重M：<span class="covid-heart-map-value" target="track-weight"></span></label>
						<div>
							<small class="m-0 text-muted float-left">0</span></small>
							<small class="m-0 text-muted float-right">10</small>
							<input type="range" class="custom-range covid-heart-map-trig" target="track-weight" value="1" min="0" step="0.5" max="10">
						</div>
					</div>
					<div class="col-12">
						<label class="m-0">影響半徑：<span class="covid-heart-map-value" target="radius"></span>公尺</label>
						<div>
							<small class="m-0 text-muted float-left">1</span></small>
							<small class="m-0 text-muted float-right">1000</small>
							<input type="range" class="custom-range covid-heart-map-trig" target="radius" value="200" min="10" step="10" max="1000">
						</div>
						<label class="m-0">最大熱度上限(疊合)：<span class="covid-heart-map-value" target="max-weight"></span></label>
						<div>
							<small class="m-0 text-muted float-left">1</span></small>
							<small class="m-0 text-muted float-right">100</small>
							<input type="range" class="custom-range covid-heart-map-trig" target="max-weight" value="20" min="1" max="100">
						</div>
					</div>
				</div>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-exclamation-triangle mr-2"></i>疫情警示區域門檻設定</h5>
				<div class="input-group input-group-sm">
					<div class="input-group-prepend">
						<span class="input-group-text">時段選擇</span>
					</div>
					<input type="text" class="form-control date-picker covid-alert-village-setting" target="start_time" value="${newestDateParam.confirmed.start.slice(0,4)}-${newestDateParam.confirmed.start.slice(4,6)}-${newestDateParam.confirmed.start.slice(6,8)}">
					<input type="text" class="form-control date-picker covid-alert-village-setting" target="end_time" value="${newestDateParam.confirmed.end.slice(0,4)}-${newestDateParam.confirmed.end.slice(4,6)}-${newestDateParam.confirmed.end.slice(6,8)}">
				</div>
				<div class="input-group input-group-sm">
					<div class="input-group-prepend">
						<span class="input-group-text">行政區累計確診數達</span>
					</div>
					<input type="text" placeholder="填入數字" class="form-control covid-alert-village-setting" target="town_sum">
					<div class="input-group-append">
						<span class="input-group-text">以上</span>
					</div>
				</div>
				<div class="input-group input-group-sm">
					<div class="input-group-prepend">
						<span class="input-group-text">行政區近</span>
					</div>
					<input type="text" placeholder="填入數字" value="0" class="form-control covid-alert-village-setting" target="town_growth_with_n_day">
					<div class="input-group-append">
						<span class="input-group-text">天，確診數平均達</span>
					</div>
					<input type="text" placeholder="填入數字" value="0" class="form-control covid-alert-village-setting" target="town_growth">
					<div class="input-group-append">
						<span class="input-group-text">以上</span>
					</div>
				</div>
				<div class="input-group input-group-sm">
					<div class="input-group-prepend">
						<span class="input-group-text">行政區內村里確診數達</span>
					</div>
					<input type="text" placeholder="填入數字" class="form-control covid-alert-village-setting" target="village_sum">
					<div class="input-group-append">
						<span class="input-group-text">以上</span>
					</div>
				</div>
				<button type="button" class="btn btn-success btn-sm btn-block mt-2 mb-2" id="covid-alert-village-search">查詢</button>
				<div id="covid-alert-village-search-table-container"></div>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2 "><i class="fab fa-delicious mr-2"></i>區域風險象限圖</h5>
				<div class="input-group input-group-sm mb-2 ">
					<div class="input-group-prepend">
						<span class="input-group-text">週次查詢選擇</span>
					</div>
					<select class="custom-select" id="covid-risk-quadrant-week-selector">
						<option>資料介接中...</option>
					</select>
				</div>
				<div class="" id="covid-risk-quadrant-container"></div>
				<hr class="mt-1 mb-1 ">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-expand-arrows-alt mr-2"></i>區域擴散比例資訊</h5>
				<div class="input-group input-group-sm">
					<div class="input-group-prepend">
						<span class="input-group-text">日期查詢選擇</span>
					</div>
					<select class="custom-select" id="covid-region-date-selector"></select>
				</div>
				<div class="w-100 h-250 mt-2" id="covid-town-spread-chart"></div>`,
			infection: `
				<h5 class="font-weight-bold mt-2"><i class="fas fa-clipboard mr-2"></i>疫調數資訊</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						目前累計總疫調數達
						<hr class="m-2">
						<h5 class="font-weight-bold m-0 text-danger" id="covid-total-number-infection"></h5>
					</div>
				</div>
				<div class="w-100 h-350 mt-2" id="covid-timeseries-chart-infection"></div>
				<p class="text-muted m-0">*註：您可點擊長條圖或是拖拉圖面進行時間選擇篩選</p>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-chart-bar mr-2"></i>區域疫調數資訊<button id="covid-filter-reset-trig-infection" map-type="infection" type="button" class="btn btn-sm float-right btn-secondary">重新篩選</button></h5>
				<div class="card shadow-sm" id="covid-time-range-total-number-infection"></div>
				<div class="position-relative">
					<div class="w-100 h-300 mt-2" id="covid-town-chart-infection"></div>
					<button type="button" class="btn btn-success btn-sm position-absolute d-none" id="covid-alert-table-download-all-infection" style="top: 0px; left: 0px;">表單下載</button>
				</div>
				<div class="w-100 d-none" id="covid-village-total-chart-container-infection">
					<div class="position-relative">
						<div class="w-100 h-250" id="covid-village-total-chart-infection"></div>
						<button type="button" class="btn btn-success btn-sm position-absolute d-none" id="covid-alert-table-download-town-infection" style="top: 0px; left: 0px;">表單下載</button>
					</div>
					<p class="text-muted m-0">*註：若顯示效果不佳，請調整側資訊區塊寬度</p>
				</div>`,	
			isolation: `
				<h5 class="font-weight-bold mt-2"><i class="fas fa-clipboard mr-2"></i>居家照護數資訊</h5>
				<div class="card shadow-sm">
					<div class="card-body text-center">
						目前累計總居家照護數達
						<hr class="m-2">
						<h5 class="font-weight-bold m-0 text-danger" id="covid-total-number-isolation"></h5>
					</div>
				</div>
				<div class="w-100 h-350 mt-2" id="covid-timeseries-chart-isolation"></div>
				<p class="text-muted m-0">*註：您可點擊長條圖或是拖拉圖面進行時間選擇篩選</p>
				<hr class="mt-1 mb-1">
				<h5 class="font-weight-bold mt-2"><i class="fas fa-chart-bar mr-2"></i>區域居家照護數資訊<button id="covid-filter-reset-trig-isolation" map-type="isolation" type="button" class="btn btn-sm float-right btn-secondary">重新篩選</button></h5>
				<div class="card shadow-sm" id="covid-time-range-total-number-isolation"></div>
				<div class="position-relative">
					<div class="w-100 h-300 mt-2" id="covid-town-chart-isolation"></div>
					<button type="button" class="btn btn-success btn-sm position-absolute d-none" id="covid-alert-table-download-all-isolation" style="top: 0px; left: 0px;">表單下載</button>
				</div>
				<div class="w-100 d-none" id="covid-village-total-chart-container-isolation">
					<div class="position-relative">
						<div class="w-100 h-250" id="covid-village-total-chart-isolation"></div>
						<button type="button" class="btn btn-success btn-sm position-absolute d-none" id="covid-alert-table-download-town-isolation" style="top: 0px; left: 0px;">表單下載</button>
					</div>
					<p class="text-muted m-0">*註：若顯示效果不佳，請調整側資訊區塊寬度</p>
				</div>`,	
		},
		staObject = {
			confirmed: {
				case: {},
				date: {},
				beforeDate: {}
			},
			track: {
				case: {},
				date: {},
				beforeDate: {}
			},
			infection: {
				case: {},
				date: {},
				beforeDate: {}
			},
			infectionUnsloved: {
				case: {},
				date: {},
				beforeDate: {},
				sum: 0
			},
			infectionSloved: {
				case: {},
				date: {},
				beforeDate: {},
				sum: 0
			},
			isolation: {
				case: {},
				date: {},
				beforeDate: {},
				sum: 0
			}
		}
	// 頁面初始化
	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("疫情專區")
		}, false) +
		`<hr class="mt-2 mb-2">
		${covidHtml.projectList}
		<hr class="mt-2 mb-2">
		${covidHtml.map}
		<hr>
		<ul class="nav nav-tabs mt-10p" role="tablist">
			<li class="nav-item w-20 text-center">
				<a class="nav-link active" data-toggle="tab" href="#topic-covid-info-confirmed" role="tab">確診</a>
			</li>
			<li class="nav-item w-20 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-covid-info-track" role="tab">足跡</a>
			</li>
			<li class="nav-item w-20 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-covid-info-risk" role="tab">風險</a>
			</li>
			<li class="nav-item w-20 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-covid-info-infection" role="tab">疫調</a>
			</li>
			<li class="nav-item w-20 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-covid-info-isolation" role="tab">照護</a>
			</li>
		</ul>
		<div class="tab-content">
			<div class="tab-pane fade show active" role="tabpanel" id="topic-covid-info-confirmed">
				<div class="card-body p-0">
					${covidHtml.basic}
				</div>
			</div>
			<div class="tab-pane fade" role="tabpanel" id="topic-covid-info-track">
				<div class="card-body p-0">
					${covidHtml.track}
				</div>
			</div>
			<div class="tab-pane fade" role="tabpanel" id="topic-covid-info-risk">
				<div class="card-body p-0">
					${covidHtml.alert}
				</div>
			</div>
			<div class="tab-pane fade" role="tabpanel" id="topic-covid-info-infection">
				<div class="card-body p-0">
					${covidHtml.infection}
				</div>
			</div>
			<div class="tab-pane fade" role="tabpanel" id="topic-covid-info-isolation">
				<div class="card-body p-0">
					${covidHtml.isolation}
				</div>
			</div>
		</div>`
	)
	// 日期選單
	$('.date-picker').datepicker({
		format: 'yyyy-mm-dd',
		orientation: 'bottom'
	})
	// 疫情專案選擇
	$("#covid-project-trig").click(function(){
		$("#t_covid19").attr("covid-project-default-key", $("#covid-project-selector").val())
		$("#t_covid19").attr("covid-project-default-start", $("#covid-project-start").val())
		$("#t_covid19").attr("covid-project-default-end", $("#covid-project-end").val())
		$("#t_covid19").click()
	})	
	// 疫情基礎資料處理
	allCovidData.forEach(element => {
		if (element.EpidemicStatus === 'footprint') {
			// 擴散計算
			var thisDate = String(element.RPT_TIME).slice(0, 8)
			if (!staObject.track.date[thisDate]) {
				staObject.track.date[thisDate] = 0
				staObject.track.case[thisDate] = {
					point: [],
					region: {}
				}
			}
			staObject.track.date[thisDate] += 1
			staObject.track.case[thisDate].point.push(element)
			if (!staObject.track.case[thisDate].region[condition_area(element.TID)]) {
				staObject.track.case[thisDate].region[condition_area(element.TID)] = 0
			}
			staObject.track.case[thisDate].region[condition_area(element.TID)] += 1
			// geoJSON產製
			allCovidTrackData.features.push({
				"type": "Feature",
				"geometry": {
					  "type": "Point",
					  "coordinates": [element.WGS_X, element.WGS_Y]
				},
				"properties": {
					"TID": element.TID,
					"DISA_TYPE": element.DISA_TYPE,
					"STATUS": element.STATUS,
					"lon": element.WGS_X,
					"lat": element.WGS_Y,
					"PRJ_ID": element.PRJ_ID,
					"DISA_NO": element.DISA_NO,
					"RPT_TIME": element.RPT_TIME,
					"location": element.DISA_LOCATION,
					"EpidemicStatus": element.EpidemicStatus,
					"project_id_type": "ALL",
					"VIL": element.VIL
				}
			})
		}
		if (element.EpidemicStatus === 'affected_light') {
			// 擴散計算
			var thisDate = String(element.RPT_TIME).slice(0, 8)
			if (!staObject.confirmed.date[thisDate]) {
				staObject.confirmed.date[thisDate] = 0
				staObject.confirmed.case[thisDate] = {
					point: [],
					region: {}
				}
			}
			staObject.confirmed.date[thisDate] += 1
			staObject.confirmed.case[thisDate].point.push(element)
			if (!staObject.confirmed.case[thisDate].region[condition_area(element.TID)]) {
				staObject.confirmed.case[thisDate].region[condition_area(element.TID)] = 0
			}
			staObject.confirmed.case[thisDate].region[condition_area(element.TID)] += 1
			// geoJSON產製
			geoJson.features.push({
				"type": "Feature",
				"geometry": {
					  "type": "Point",
					  "coordinates": [element.WGS_X, element.WGS_Y]
				},
				"properties": {
					"TID": element.TID,
					"DISA_TYPE": element.DISA_TYPE,
					"STATUS": element.STATUS,
					"WGS_X": element.WGS_X,
					"WGS_Y": element.WGS_Y,
					"PRJ_ID": element.PRJ_ID,
					"DISA_NO": element.DISA_NO,
					"RPT_TIME": element.RPT_TIME,
					"DISA_LOCATION": element.DISA_LOCATION,
					"EpidemicStatus": element.EpidemicStatus,
					"project_id_type": "ALL",
					"VIL": element.VIL,
					"DATE": thisDate
				}
			})
		}
	})
	geoJson.features.reverse()
	// 疫調點位
	infectionData.forEach(element => {
		element.RPT_TIME = String(element.Confirmed.replace(/-| |:/g,''))
		if (element.Area.length != 3) {
			if (Number(element.Area) < 10) {
				element.TID = "00" + element.Area
			} else {
				element.TID = "0" + element.Area
			}
		} else {
			element.TID = element.Area
		}
		// 擴散計算
		var thisDate = String(element.RPT_TIME).slice(0, 8),
			thisStatus = element.CaseStatus,
			thisKey = ["infection"]
		if (thisStatus === "解除列管") {
			thisKey.push("infectionSloved")
		} else {
			thisKey.push("infectionUnsloved")
		}
		thisKey.forEach(eachKey => {
			if (!staObject[eachKey].date[thisDate]) {
				staObject[eachKey].date[thisDate] = 0
				staObject[eachKey].case[thisDate] = {
					point: [],
					region: {}
				}
			}
			staObject[eachKey].date[thisDate] += 1
			staObject[eachKey].case[thisDate].point.push(element)
			if (!staObject[eachKey].case[thisDate].region[condition_area(element.TID)]) {
				staObject[eachKey].case[thisDate].region[condition_area(element.TID)] = 0
			}
			staObject[eachKey].case[thisDate].region[condition_area(element.TID)] += 1
			if (eachKey !== "infection") {
				staObject[eachKey].sum += 1
			}
		})
		// geoJSON產製
		element = Object.assign(
			element, 
			{
				"TID": element.TID,
				"DISA_TYPE": element.InfectionSource,
				"STATUS": element.CaseStatus,
				"WGS_X": element.WGS_X,
				"WGS_Y": element.WGS_Y,
				"DISA_NO": element.CaseNo,
				"RPT_TIME": element.RPT_TIME,
				"DISA_LOCATION": element.Location,
				"VIL": element.Vil
			}
		)
		geoJsonInfection.features.push({
			"type": "Feature",
			"geometry": {
				"type": "Point",
				"coordinates": [element.WGS_X, element.WGS_Y]
			},
			"properties": element
		})
	})
	// 居家照護點位
	infectionData.forEach(element => {
		let thisElement = Object.create(element);
		if (thisElement.ToOne_X && thisElement.ToOne_Y) {
			thisElement.RPT_TIME = String(thisElement.Confirmed.replace(/-| |:/g,''))
			if (thisElement.ToOneArea.length != 3) {
				if (Number(thisElement.ToOneArea) < 10) {
					thisElement.TID = "00" + thisElement.ToOneArea
				} else {
					thisElement.TID = "0" + thisElement.ToOneArea
				}
			} else {
				thisElement.TID = thisElement.ToOneArea
			}
			// geoJSON產製
			thisElement = Object.assign(
				thisElement, 
				{
					"TID": thisElement.TID,
					"DISA_TYPE": thisElement.InfectionSource,
					"STATUS": thisElement.CaseStatus,
					"WGS_X": thisElement.ToOne_X,
					"WGS_Y": thisElement.ToOne_Y,
					"DISA_NO": thisElement.CaseNo,
					"RPT_TIME": thisElement.RPT_TIME,
					"DISA_LOCATION": thisElement.Location,
					"VIL": thisElement.ToOneVil
				}
			)
			geoJsonIsolation.features.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [thisElement.ToOne_X, thisElement.ToOne_Y]
				},
				"properties": thisElement
			})
		}
	})
	// 居家照護點位staObject計算
	geoJsonIsolation.features.forEach(feature => {
		let element = feature.properties,
			thisDate = String(element.RPT_TIME).slice(0, 8)
		if (!staObject.isolation.date[thisDate]) {
			staObject.isolation.date[thisDate] = 0
			staObject.isolation.case[thisDate] = {
				point: [],
				region: {}
			}
		}
		staObject.isolation.date[thisDate] += 1
		staObject.isolation.case[thisDate].point.push(element)
		if (!staObject.isolation.case[thisDate].region[condition_area(element.TID)]) {
			staObject.isolation.case[thisDate].region[condition_area(element.TID)] = 0
		}
		staObject.isolation.case[thisDate].region[condition_area(element.TID)] += 1
		staObject.isolation.sum += 1
	})
	// 日期、擴散物件與確診總數計算
	var dateList = {
			confirmed: Object.keys(staObject.confirmed.date),
			track: Object.keys(staObject.track.date),
			infection: Object.keys(staObject.infection.date),
			infectionUnsloved: Object.keys(staObject.infectionUnsloved.date),
			infectionSloved: Object.keys(staObject.infectionSloved.date),
			isolation: Object.keys(staObject.isolation.date)
		},
		info = {
			confirmed: {
				dateList: [],
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.confirmed.length-1),
				regionDateOptionHtml: ""
			},
			track: {
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.track.length-1),
				regionDateOptionHtml: ""
			},
			infection: {
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.infection.length-1),
				regionDateOptionHtml: ""
			},
			infectionUnsloved: {
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.infectionUnsloved.length-1),
				regionDateOptionHtml: ""
			},
			infectionSloved: {
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.infectionSloved.length-1),
				regionDateOptionHtml: ""
			},
			isolation: {
				dateAdd: [],
				dateBeforeAdd: [],
				sum: 0,
				lastDayIndex: (dateList.isolation.length-1),
				regionDateOptionHtml: ""
			}
		}
	Object.keys(staObject).forEach(eachParameter => {
		dateList[eachParameter].forEach( (el, index) => {
			if (index === 0) {
				staObject[eachParameter].beforeDate[el] = 0
			} else {
				info[eachParameter].sum += staObject[eachParameter].date[dateList[eachParameter][(index - 1)]]
				staObject[eachParameter].beforeDate[el] = info[eachParameter].sum
			}
			info[eachParameter].dateAdd.push([event_time_processing(el + "000000"), staObject[eachParameter].date[dateList[eachParameter][index]]])
			info[eachParameter].dateBeforeAdd.push([event_time_processing(el + "000000"), staObject[eachParameter].beforeDate[dateList[eachParameter][index]]])
			if (index === (dateList[eachParameter].length-1)) {
				info[eachParameter].sum = staObject[eachParameter].date[dateList[eachParameter][index]] + staObject[eachParameter].beforeDate[dateList[eachParameter][index]]
			}
			info[eachParameter].regionDateOptionHtml += `<option value="${index}">${el.slice(0,4)}-${el.slice(4,6)}-${el.slice(6,8)}</option>`
		})
	})
	$("#covid-total-number").html(info.confirmed.sum + "例")
	$("#covid-total-number-track").html(allCovidTrackData.features.length + "點")
	$("#covid-total-number-infection").html(geoJsonInfection.features.length + "點(追蹤" + staObject.infectionUnsloved.sum + "點、解列" + staObject.infectionSloved.sum + "點)")
	$("#covid-total-number-isolation").html(geoJsonIsolation.features.length + "點")

	// 擴散清單
	$("#covid-region-date-selector").html(info.confirmed.regionDateOptionHtml).change(function(){
		var target = $(this).val()
		if (target !== null) {
			renderSpreadChart(parseInt(target))
		}
	})
	var $sel = $('#covid-region-date-selector'), 
		$o = $sel.children().toArray().reverse();
	$sel.append($o);
	$("#covid-region-date-selector").val(String(info.confirmed.lastDayIndex)).trigger('change')
	// 時間序列圖
	Object.values(chartParameter).forEach(eachParameter => {
		var seriesOption = []
		switch (eachParameter.name) {
			case "確診點":
				let array = {
					"in_7day": {
						"7": [],
						"6": [],
						"5": [],
						"4": [],
						"3": [],
						"2": [],
						"1": [],
						"0": []
					},
					"not_in_7day": []
				}
				info[eachParameter.keyName].dateAdd.forEach((el, index) => {
					let diffIndex = info[eachParameter.keyName].lastDayIndex - index
					if (diffIndex > 7) {
						array.not_in_7day.push(el)
					} else {
						array.in_7day[String(diffIndex)].push(el)
					}
				})
				seriesOption.push({
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: info[eachParameter.keyName].dateAdd,
					tooltip: { valueDecimals: 0},
					color: eachParameter.timeSeries.color,
					visible: false
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: array.not_in_7day,
					tooltip: { valueDecimals: 0},
					color: "#4575b4"
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: array.not_in_7day,
					yAxis: 1,
					tooltip: {
						pointFormat: ''
					},
					color: "#4575b4"
				})
				Object.keys(array.in_7day).forEach((eachDay, index) => {
					seriesOption.push({
						type: 'column',
						name: eachParameter.timeSeries.series.up,
						data: array.in_7day[eachDay],
						tooltip: { valueDecimals: 0},
						color: chartParameter.confirmed.colorPalette[String(index)]
					}, {
						type: 'column',
						name: eachParameter.timeSeries.series.up,
						data: array.in_7day[eachDay],
						yAxis: 1,
						tooltip: {
							pointFormat: ''
						},
						color: chartParameter.confirmed.colorPalette[String(index)]
					})
				})
				seriesOption.push({
					type: 'column',
					name: eachParameter.timeSeries.series.down,
					data: info[eachParameter.keyName].dateBeforeAdd,
					yAxis: 1,
					color: 'black',
					tooltip: { valueDecimals: 0}
				})
				break
			case "足跡點":
				seriesOption = [{
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: info[eachParameter.keyName].dateAdd,
					tooltip: { valueDecimals: 0},
					color: eachParameter.timeSeries.color
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: info[eachParameter.keyName].dateAdd,
					yAxis: 1,
					tooltip: {
						pointFormat: ''
					},
					color: eachParameter.timeSeries.color
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.down,
					data: info[eachParameter.keyName].dateBeforeAdd,
					yAxis: 1,
					color: 'black',
					tooltip: { valueDecimals: 0}
				}]
				break
			case "疫調點":
				seriesOption = [{
					type: 'column',
					name: eachParameter.timeSeries.series.up + "(解除列管)",
					data: info.infectionSloved.dateAdd,
					tooltip: { valueDecimals: 0},
					color: "limegreen"
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up + "(持續追蹤)",
					data: info.infectionUnsloved.dateAdd,
					tooltip: { valueDecimals: 0},
					color: "darkorchid"
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up + "(解除列管)",
					data: info.infectionSloved.dateAdd,
					yAxis: 1,
					tooltip: {
						pointFormat: ''
					},
					color: "limegreen"
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up + "(持續追蹤)",
					data: info.infectionUnsloved.dateAdd,
					yAxis: 1,
					tooltip: {
						pointFormat: ''
					},
					color: "darkorchid"
				},{
					type: 'column',
					name: eachParameter.timeSeries.series.down,
					data: info[eachParameter.keyName].dateBeforeAdd,
					yAxis: 1,
					color: 'black',
					tooltip: { valueDecimals: 0}
				}]
				break
			case "居家照護點":
				seriesOption = [{
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: info[eachParameter.keyName].dateAdd,
					tooltip: { valueDecimals: 0},
					color: eachParameter.timeSeries.color
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.up,
					data: info[eachParameter.keyName].dateAdd,
					yAxis: 1,
					tooltip: {
						pointFormat: ''
					},
					color: eachParameter.timeSeries.color
				}, {
					type: 'column',
					name: eachParameter.timeSeries.series.down,
					data: info[eachParameter.keyName].dateBeforeAdd,
					yAxis: 1,
					color: 'black',
					tooltip: { valueDecimals: 0}
				}]
				break
		}
		Highcharts.stockChart('covid-timeseries-chart' + eachParameter.div, {
			chart: {
				zoomType: 'x',
			},
			rangeSelector: {
				enabled: false
			},
			navigator: {
				enabled: true,
				height: 20
			},
			scrollbar: {
				enabled: true
			},
			title: {
				text: eachParameter.timeSeries.chartTitle
			},
			plotOptions: {
				column: {
					stacking: 'normal'
				},
				series: {
					cursor: 'pointer',
					point: {
						events: {
							click: function () {
								var selectDateString = new Date(this.category).toISOString().slice(0,10).replaceAll('-', '')
								renderRegionChart({
										min: selectDateString,
										max: selectDateString
									},
									eachParameter.keyName
								)
							}
						}
					}
				}
			},
			xAxis: {
				dateTimeLabelFormats: {
					millisecond: '%H:%M:%S',
					second: '%H:%M:%S',
					minute: '%H:%M',
					hour: '%H:%M',
					day: '%m/%e',
					week: '%e. %b',
					month: '%Y/%m',
					year: '%Y'
				},
				labels: {
					style: {
						fontWeight: 'bold',
						color: 'rgba(0, 0, 0, 1)',
						fontSize: '12px'
					}
				},
				events: {
					setExtremes: function (e) {
						var timePick = { min: e.min, max: e.max }
						if (timePick.max !== undefined) {
							var thisMaxDateString = new Date(timePick.max).toISOString(),
								thisMinDateString = new Date(timePick.min).toISOString()
							if (thisMinDateString.slice(11,13) != "00") {
								thisMinDateString = new Date(timePick.min + (3600000 * 24)).toISOString()
							}
							renderRegionChart({
									min: thisMinDateString.slice(0,10).replaceAll('-', ''),
									max: thisMaxDateString.slice(0,10).replaceAll('-', '')
								},
								eachParameter.keyName
							)
						} else {
							renderRegionChart(undefined, eachParameter.keyName)
						}
					}
				}
			},
			yAxis: [{
					labels: {
						align: 'right',
						x: 10,
						style: {
							fontWeight: 'bold',
							color: 'rgba(0, 0, 0, 1)',
							fontSize: '12px'
						}
					},
					title: {
						text: eachParameter.timeSeries.yAxisTitle.up
					},
					height: '45%',
					lineWidth: 2,
					resize: {
						enabled: true
					},
					stackLabels: {
						enabled: true,
						style: {
							fontWeight: 'bold',
							color: 'rgba(0, 0, 0, 1)'
						}
					}
				}, {
					labels: {
						align: 'right',
						x: 10,
						style: {
							fontWeight: 'bold',
							color: 'rgba(0, 0, 0, 1)',
							fontSize: '12px'
						}
					},
					title: {
						text: eachParameter.timeSeries.yAxisTitle.down
					},
					top: '55%',
					height: '45%',
					offset: 0,
					lineWidth: 2,
					stackLabels: {
						enabled: true,
						style: {
							fontWeight: 'bold',
							color: 'rgba(0, 0, 0, 1)'
						}
					}
				}
			],
			tooltip: {
				split: true
			},
			series: seriesOption
		})
	})
	
	$("#covid-filter-reset-trig, #covid-filter-reset-trig-track, #covid-filter-reset-trig-infection, #covid-filter-reset-trig-isolation").click(function(){
		var targetKey = $(this).attr('map-type')
		timePickSetting[targetKey] = undefined
		renderRegionChart(timePickSetting[targetKey], targetKey)
	}).click()
	
	// 熱度圖設定
	$(".covid-heart-map-trig").change(function(){
		$(".covid-heart-map-trig").each(function(){
			var thisValue = $(this).val(),
				thisTargetName = $(this).attr('target')
			if (thisTargetName === "start_time" || thisTargetName === "end_time") {
				thisValue = $(this).val().replaceAll("-", "")
			} else {
				thisValue = Number($(this).val())
			}
			heatMapParameterSetting[thisTargetName] = thisValue
			$('.covid-heart-map-value[target="' + thisTargetName + '"]').html(String(thisValue))
		})
		if (map.hasLayer(overlay_dataset["NX+MY混和熱度圖"])) {
			map.removeLayer(overlay_dataset["NX+MY混和熱度圖"])
			overlay_dataset["NX+MY混和熱度圖"] = covidOverlayMapList["NX+MY混和熱度圖"].action()
			map.addLayer(overlay_dataset["NX+MY混和熱度圖"])
		}
	}).trigger('change')

	// 疫情套疊圖處理
	var covidOverlayMapListHtml = ''
	Object.keys(covidOverlayMapList).forEach(eachKey => {
		var statusObject = { open: '', close: ''}, additionHtml = ""
		if (covidOverlayMapList[eachKey].additionHtml) {
			additionHtml = covidOverlayMapList[eachKey].additionHtml
		}
		statusObject[covidOverlayMapList[eachKey].defaultStatus] = 'selected'
		covidOverlayMapListHtml += `
			<div class="input-group input-group-sm mb-1">
				<div class="input-group-prepend">
					<label class="input-group-text">${eachKey}</label>
				</div>
				<select class="custom-select covid-overlaymap-trig topic-layer-control" target="${eachKey}">
					<option value="open" ${statusObject.open}>開啟</option>
					<option value="close" ${statusObject.close}>關閉</option>
				</select>
				${additionHtml}
			</div>`
		
	})
	$("#covid-overlaymap-container").html(covidOverlayMapListHtml)
	$(".covid-overlaymap-trig").change(function(){
		var target = $(this).attr('target'), action = $(this).val()
		switch (action) {
			case "open":
				if (!covidOverlayMapList[target].data) {
					covidOverlayMapList[target].data = covidOverlayMapList[target].action()
				}
				if (covidOverlayMapList[target].except) {
					covidOverlayMapList[target].except()	
				}
				if (target !== "確診者點位圖X" && target !== "確診者足跡點位圖Y") {
					overlay_dataset[target] = covidOverlayMapList[target].data	
				} else {
					overlay_dataset[target] = covidOverlayMapList[target].action()
				}
				map.addLayer(overlay_dataset[target])
				break
			case "close":
				map.removeLayer(overlay_dataset[target])
				break
		}
	})
	$('.covid-overlaymap-trig[target="NX+MY混和熱度圖"]').val("open").trigger('change')
	
	// 確診點、足跡點樣式切換
	$("#covid-map-style, #covid-map-style-track, #covid-map-style-infection, #covid-map-style-isolation").change(function(){
		var targetKey = $(this).attr('map-type')
		mapStyleSetting[targetKey] = $(this).val()
		renderRegionChart(timePickSetting[targetKey], targetKey)
	})
	// 相關函式
	function renderCovidMap(filterGeoJson, targetMapName){
		var initialOpenBool = map.hasLayer(overlay_dataset[chartParameter[targetMapName].map.layerName])
		if (initialOpenBool) {
			map.removeLayer(overlay_dataset[chartParameter[targetMapName].map.layerName])
		}
		leafletExtendTileHandle()
		switch (mapStyleSetting[targetMapName]) {
			case "normal":
				var covidLayer
				switch (targetMapName) {
					case "confirmed":
						covidLayer = L.geoJson(filterGeoJson, {
							pointToLayer: function(feature, latlng) {
								let	markerColor,
									markerColorIndex = (dateList.confirmed.length - 1) - dateList.confirmed.indexOf(feature.properties["DATE"])
								if (markerColorIndex > 7) {
									markerColor = "#4575b4"
								} else {
									markerColor = chartParameter.confirmed.colorPalette[String(markerColorIndex)]
								}
								return L.circleMarker(latlng, {
									radius: chartParameter[targetMapName].map.size,
									fillOpacity: 1,
									fillColor: markerColor,
									color: 'black',
									weight: 1
								}).bindPopup('<div id="other_area">資料連結中...</div>');
							}
						})
						break
					case "track":
						covidLayer = L.geoJson(filterGeoJson, {
							pointToLayer: function(feature, latlng) {
								return L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: 'marker_icon/covid_triangle.png',
										size: [12, 12],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
							}
						})
						break
					case "infection":
						covidLayer = L.geoJson(filterGeoJson, {
							pointToLayer: function(feature, latlng) {
								let iconUrl = 'marker_icon/covid_square.png'
								if (feature.properties.CaseStatus === "解除列管") {
									iconUrl = 'marker_icon/covid_square_g.png'
								}
								return L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: iconUrl,
										size: [12, 12],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
							}
						})
						break
					case "isolation":
						covidLayer = L.geoJson(filterGeoJson, {
							pointToLayer: function(feature, latlng) {
								return L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: 'marker_icon/covid_isolation.png',
										size: [14, 14],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
							}
						})
						break
				}
				overlay_dataset[chartParameter[targetMapName].map.layerName] = covidLayer
				break
			case "cluster":
				var covidLayer = L.geoJson(filterGeoJson, {
					pointToLayer: function(feature, latlng) {
						let result
						switch (targetMapName) {
							case "confirmed":
								let	markerColor,
									markerColorIndex = (dateList.confirmed.length - 1) - dateList.confirmed.indexOf(feature.properties["DATE"])
								if (markerColorIndex > 7) {
									markerColor = "#4575b4"
								} else {
									markerColor = chartParameter.confirmed.colorPalette[String(markerColorIndex)]
								}
								result = L.circleMarker(latlng, {
									radius: chartParameter[targetMapName].map.size,
									fillOpacity: 1,
									fillColor: markerColor,
									color: 'black',
									weight: 1
								}).bindPopup('<div id="other_area">資料連結中...</div>');
								break
							case "track":
								result = L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: 'marker_icon/covid_triangle.png',
										size: [12, 12],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
								break
							case "infection":
								let iconUrl = 'marker_icon/covid_square.png'
								if (feature.properties.CaseStatus === "解除列管") {
									iconUrl = 'marker_icon/covid_square_g.png'
								}
								result = L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: iconUrl,
										size: [12, 12],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
								break
							case "isolation":
								result = L.canvasMarker(latlng, {
									radius: 8,
									img: {
										url: 'marker_icon/covid_isolation.png',
										size: [14, 14],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_area">資料連結中...</div>');
								break
						}
						return result
					}
				})
				overlay_dataset[chartParameter[targetMapName].map.layerName] = L.markerClusterGroup({
					iconCreateFunction: function (cluster) {
						var childCount = cluster.getChildCount();
						return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster' + ' marker-cluster-small_' + chartParameter[targetMapName].map.clusterStyle, iconSize: new L.Point(30, 30) });
					}
				});
				overlay_dataset[chartParameter[targetMapName].map.layerName].addLayer(covidLayer)
				break
		}
		if (initialOpenBool) {
			map.addLayer(overlay_dataset[chartParameter[targetMapName].map.layerName])	
		}
		if (mapStyleSetting[targetMapName] === 'normal' || mapStyleSetting[targetMapName] === 'cluster') {
			var clickEvent,
				thisLayerName = chartParameter[targetMapName].map.layerName
			if (thisLayerName === "疫調點位圖") {
				clickEvent = function(e){
					setTimeout(function(){
						var url = publicPath + '/napi/emis/covid_infection_contact?case_no=' + e.layer.feature.properties.DISA_NO,
							thisDetailed = ajax_call(url),
							infectionRelationHtmlSub = {},
							infectionRelationHtml = "",
							infectionRelationTable = {
								display: "d-none",
								html: ""
							},
							thisFeatures = e.layer.feature.properties
						if (thisDetailed.stat.length === 0) {
							infectionRelationHtml = "無資料"
						} else {
							thisDetailed.stat.forEach(el => {
								if (!infectionRelationHtmlSub[el.ContactStatus]) {
									infectionRelationHtmlSub[el.ContactStatus] = ""
								}
								infectionRelationHtmlSub[el.ContactStatus] += `<br>快篩${el.RapidScreening}且PCR${el.PCR}共${el.count}人`
							})
							Object.keys(infectionRelationHtmlSub).forEach(el => {
								infectionRelationHtml += `<li class="mb-1">${el}：${infectionRelationHtmlSub[el]}</li>`
							})
							infectionRelationHtml = '<ul>' + infectionRelationHtml + '</ul>'
							infectionRelationTable.display = ""
							thisDetailed.detail.forEach(el => {
								infectionRelationTable.html += `
									<tr>
										<td>${el.ContactStatus}</td>
										<td>${el.Name}</td>
										<td>${null_Converter_v3(el.Gender)}</td>
										<td>${null_Converter_v3(el.Age)}</td>
										<td>${null_Converter_v3(el.Relationship)}</td>
										<td>${null_Converter_v3(el.RapidScreeningDT)}<br>${null_Converter_v3(el.RapidScreening)}</td>
										<td>${null_Converter_v3(el.PCRDT)}<br>${null_Converter_v3(el.PCR)}</td>
									</tr>`
							})
						}
						$('#other_area').html(
							'<h5 class="font-weight-bold">行政區：' + condition_area(thisFeatures.TID) + '</h5>' + 
							'<h6 class="float-right">案件編號：' + thisFeatures.DISA_NO + '</h6>' +
							'<h6>通報時間：' + timeConverter(thisFeatures.RPT_TIME)  + '</h6>' + 
							'<h6>地址：' + thisFeatures.DISA_LOCATION + '</h6>' + 
							'<h6>狀態：' + thisFeatures.CaseStatus + '</h6>' +
							'<h6>感染來源：' + null_Converter_v3(thisFeatures.InfectionSource) + '</h6>' +
							'<h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="' + thisFeatures.WGS_X + '" lat="' + thisFeatures.WGS_Y + '">另開分頁檢視</button></h6>' +
							'<h6>詳細資訊與處理歷程：<button type="button" class="btn btn-link p-0" id="infection-detailed-trig">檢視</button></h6>' +
							'<h6>匡列疫調對象：' + infectionRelationHtml + '</h6>'
						)
						$('#infection-detailed-trig').click(function(){
							var detailedHtml = `
								<div class="row">
									<div class="col-6">
										<h5 class="font-weight-bold">◈ 個案資訊</h5>
										<table class="table table-bordered">
											<thead class="thead-dark">
												<tr>
													<th style="width: 100px;">姓名</th>
													<td>${thisFeatures.Name}</td>
												</tr>
												<tr>
													<th style="width: 100px;">性別</th>
													<td>${thisFeatures.Gender}</td>
												</tr>
												<tr>
													<th style="width: 100px;">年齡</th>
													<td>${thisFeatures.Age}</td>
												</tr>
												<tr>
													<th style="width: 100px;">地址</th>
													<td>${thisFeatures.Location}</td>
												</tr>
												<tr>
													<th style="width: 100px;">狀態</th>
													<td>${thisFeatures.CaseStatus}</td>
												</tr>
												<tr>
													<th style="width: 100px;">案號</th>
													<td>${thisFeatures.CaseNo}</td>
												</tr>
											</thead>
										</table>
									</div>
									<div class="col-6">
										<h5 class="font-weight-bold">◈ 感染資訊</h5>
										<table class="table table-bordered">
											<thead class="thead-dark">
												<tr>
													<th style="width: 100px;">感染時間</th>
													<td>${thisFeatures.Confirmed}</td>
												</tr>
												<tr>
													<th style="width: 100px;">感染來源</th>
													<td>${thisFeatures.InfectionSource}</td>
												</tr>
												<tr>
													<th style="width: 100px;">感染原因</th>
													<td>${thisFeatures.InfectionReason}</td>
												</tr>
											</thead>
										</table>
									</div>
									<div class="mt-3 col-12 ${infectionRelationTable.display}">
										<h5 class="font-weight-bold">◈ 匡列對象疫調狀況</h5>
										<table class="table table-bordered">
											<thead class="thead-dark">
												<tr>
													<th>類別</th>
													<th>姓名</th>
													<th>性別</th>
													<th>年齡</th>
													<th>關係</th>
													<th>快篩結果</th>
													<th>PCR結果</th>
												</tr>
											</thead>
											<tbody>
												${infectionRelationTable.html}
											</tbody>
										</table>
									</div>
								</div>`
							modal_open(
								detailedHtml,
								`疫調案例「${thisFeatures.DISA_NO}」詳細資訊與處理歷程`
							)
						})
					}, 1000);
				}
			} else if (thisLayerName === "居家照護點位圖") {
				clickEvent = function(e){
					var thisFeatures = e.layer.feature.properties
					setTimeout(function(){
						$('#other_area').html(
							'<h5 class="font-weight-bold">行政區：' + condition_area(thisFeatures.TID) + '</h5>' + 
							'<h6>案件編號(疫調)：' + thisFeatures.DISA_NO + '</h6>' +
							'<h6>通報時間(疫調)：' + timeConverter(thisFeatures.RPT_TIME)  + '</h6>' + 
							'<h6>所屬村里：' + null_Converter_v3(thisFeatures.VIL) + '</h6>' +
							'<h6>居家照護地址：' + null_Converter_v3(thisFeatures["ToOneAddr"]) + '</h6>' +
							'<h6>居家照護類型：' + null_Converter_v3(thisFeatures["ToOneMethod"]) + '</h6>' +
							'<h6>疫調狀態：' + thisFeatures.CaseStatus + '</h6>' +
							'<h6>感染來源：' + null_Converter_v3(thisFeatures.InfectionSource) + '</h6>' +
							'<h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="' + thisFeatures.WGS_X + '" lat="' + thisFeatures.WGS_Y + '">另開分頁檢視</button></h6>' +
							'<h6>詳細資訊(個案)：<button type="button" class="btn btn-link p-0" id="infection-detailed-trig">檢視</button></h6>'
						)
						$('#infection-detailed-trig').click(function(){
							var detailedHtml = `
								<div class="row">
									<div class="col-6">
										<h5 class="font-weight-bold">◈ 個案資訊</h5>
										<table class="table table-bordered">
											<thead class="thead-dark">
												<tr>
													<th style="width: 100px;">姓名</th>
													<td>${thisFeatures.Name}</td>
												</tr>
												<tr>
													<th style="width: 100px;">性別</th>
													<td>${thisFeatures.Gender}</td>
												</tr>
												<tr>
													<th style="width: 100px;">年齡</th>
													<td>${thisFeatures.Age}</td>
												</tr>
												<tr>
													<th style="width: 100px;">狀態</th>
													<td>${thisFeatures.CaseStatus}</td>
												</tr>
												<tr>
													<th style="width: 100px;">疫調案號</th>
													<td>${thisFeatures.CaseNo}</td>
												</tr>
												<tr>
													<th style="width: 100px;">居家照護地址</th>
													<td>${thisFeatures.ToOneAddr}</td>
												</tr>
											</thead>
										</table>
									</div>
									<div class="col-6">
										<h5 class="font-weight-bold">◈ 感染資訊</h5>
										<table class="table table-bordered">
											<thead class="thead-dark">
												<tr>
													<th style="width: 100px;">感染時間</th>
													<td>${thisFeatures.Confirmed}</td>
												</tr>
												<tr>
													<th style="width: 100px;">感染來源</th>
													<td>${thisFeatures.InfectionSource}</td>
												</tr>
												<tr>
													<th style="width: 100px;">感染原因</th>
													<td>${thisFeatures.InfectionReason}</td>
												</tr>
											</thead>
										</table>
									</div>
									<div class="col-12">
										<hr>
										<h5 class="font-weight-bold">◈ 居家照護關聯查詢</h5>
										<div class="input-group input-group-sm mb-1">
											<div class="input-group-prepend">
												<label class="input-group-text">查詢方式</label>
											</div>
											<select id="infection-detailed-relation-case-method" class="custom-select">
												<option value="地址">依照居家照護地址</option>
												<option value="案號">依照疫調案號</option>
											</select>
										</div>
										<div id="infection-detailed-relation-case-input" class="input-group input-group-sm mb-1">
											<div class="input-group-prepend">
												<label class="input-group-text">輸入地址</label>
											</div>
											<input type="text" class="form-control" placeholder="">
										</div>
										<button id="infection-detailed-relation-case-trig" type="button" class="btn btn-success btn-sm mt-2">查詢</button>
										<table id="infection-detailed-relation-case-table" class="table table-sm table-bordered mt-3">
											<thead class="thead-dark">
												<tr>
													<th rowspan="2">#</th>
													<th class="text-center" colspan="6">個案資訊</th>
													<th class="text-center" colspan="2">感染資訊</th>
												</tr>
												<tr>
													<th>案號</th>
													<th>姓名</th>
													<th>性別</th>
													<th>年齡</th>
													<th>地址</th>
													<th>狀態</th>
													<th>時間</th>
													<th>原因</th>
												</tr>
											</thead>
											<tbody>
												<tr><td colspan="9" class="text-center">-您尚未查詢-</td></tr>
											</tbody>
										</table>
									</div>`
							modal_open(
								detailedHtml,
								`個案案例「${thisFeatures.DISA_NO}」詳細資訊`,
								function(){
									// 方法切換
									$("#infection-detailed-relation-case-method").change(function(){
										let method = $(this).val(),
											inputValue = ""
										$("#infection-detailed-relation-case-input label.input-group-text").html("輸入" + method)
										switch (method) {
											case "地址":
												inputValue = thisFeatures.ToOneAddr
												break
											case "案號":
												inputValue = thisFeatures.DISA_NO
												break
										}
										$("#infection-detailed-relation-case-input input").val(inputValue)
									}).trigger("change")
									// 查詢事件綁定
									$("#infection-detailed-relation-case-trig").click(function(){
										let url = "",
											method = $("#infection-detailed-relation-case-method").val(),
											value = $("#infection-detailed-relation-case-input input").val()
										switch (method) {
											case "地址":
												url = publicPath + "/napi/emis/covid_infection?to_one_address=" + value
												break
											case "案號":
												url = publicPath + "/napi/emis/covid_infection?case_no=" + value
												break
										}
										ajax_call_async(
											url, 
											function(data){
												let tbodyHtml = ""
												if (data.length > 0) {
													data.forEach((el, index) => {
														tbodyHtml += `
															<tr>
																<td>${(index+1)}</td>
																<td>${el.CaseNo}</td>
																<td>${el.Name}</td>
																<td>${el.Gender}</td>
																<td>${el.Age}</td>
																<td>${el.ToOneAddr}</td>
																<td>${el.CaseStatus}</td>
																<td>${el.Confirmed}</td>
																<td>${el.InfectionSource}</td>
															</tr>`
													})
												} else {
													tbodyHtml = '<tr colspan="9"><td class="text-center">查無結果</td></tr>'
												}
												$("#infection-detailed-relation-case-table tbody").html(tbodyHtml)
											}
										)
									})
								}
							)
						})
					}, 1000);
				}
			} else {
				clickEvent = function(e){
					setTimeout(function(){
						var url = publicPath + '/napi/emis/event?project_id=' + e.layer.feature.properties.PRJ_ID + '&disa_no=' + e.layer.feature.properties.DISA_NO + '&type=' + e.layer.feature.properties.project_id_type,
							this_event = ajax_call(url),
							report_from_source = this_event[0].DISA_FROM
						if (report_from_source != "119轉入") { report_from_source = condition_who(report_from_source) }
						$('#other_area').html(
							'<h5 class="font-weight-bold">行政區：' + condition_area(this_event[0].TID) + '</h5>' + 
							'<h6 class="float-right">案件編號：' + this_event[0].DISA_NO + '</h6>' +
							'<h6>通報時間：' + timeConverter(this_event[0].RPT_TIME)  + '</h6>' + 
							'<h6>案件敘述：' + this_event[0].SITUATION + '</h6>' +
							'<h6>地址：' + this_event[0].DISA_LOCATION + '</h6>' + 
							'<h6>通報來源：' + report_from_source + '</h6>' +
							'<h6>類型：' + chartParameter[targetMapName].name + '</h6>' +
							'<h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="' + this_event[0].WGS_X + '" lat="' + this_event[0].WGS_Y + '">另開分頁檢視</button></h6>'
						)
					}, 1000);
				}
			}
			overlay_dataset[thisLayerName].on('click', clickEvent)
		}
	}

	function renderRegionChart(pickTime, targetMapName){
		timePickSetting[targetMapName] = pickTime
		var filterGeoJson = turf.featureCollection([]),
			targetTownArray = [],
			queryDateString = '',
			targetCaseInfo = {
				thisDay: {
					region: {}
				}
			},
			townStackedData = {
				normal: {},
				test: {}
			},
			souceJson
		// 判斷確診or足跡資料源
		switch (targetMapName) {
			case "confirmed":
				souceJson = geoJson
				break
			case "track":
				souceJson = allCovidTrackData
				break
			case "infection":
				souceJson = geoJsonInfection
				break
			case "isolation":
				souceJson = geoJsonIsolation
				break
		}
		// 篩選資料
		if (pickTime) {
			if (pickTime.min === pickTime.max) {
				queryDateString = pickTime.min.slice(0,4) + "-" + pickTime.min.slice(4,6) + "-" + pickTime.min.slice(6,8)
			} else {
				queryDateString = pickTime.min.slice(0,4) + "-" + pickTime.min.slice(4,6) + "-" + pickTime.min.slice(6,8) + " ~ " + pickTime.max.slice(0,4) + "-" + pickTime.max.slice(4,6) + "-" + pickTime.max.slice(6,8)
			}
			souceJson.features.forEach(feature => {
				var thisDateString = parseInt(String(feature.properties.RPT_TIME).slice(0, 8))
				if (thisDateString >= parseInt(pickTime.min) && thisDateString <= parseInt(pickTime.max)) {
					filterGeoJson.features.push(feature)
				}
			})
		} else {
			filterGeoJson = souceJson
			queryDateString = '全部'
		}
		// 計算區段資料區域統計數量
		filterGeoJson.features.forEach(feature => {
			var thisRegionName = condition_area(feature.properties.TID)
			if (!targetCaseInfo.thisDay.region[thisRegionName]) {
				targetCaseInfo.thisDay.region[thisRegionName] = 0
				targetTownArray.push(feature.properties.TID)
			}
			targetCaseInfo.thisDay.region[thisRegionName] += 1
		})
		Object.keys(targetCaseInfo.thisDay.region).forEach(eachRegion => {
			townStackedData.normal[eachRegion] = { point: targetCaseInfo.thisDay.region[eachRegion] }
		})
		// 物件渲染
		if (!$("#covid-village-total-chart-container" + chartParameter[targetMapName].div).hasClass('d-none')) {
			$("#covid-village-total-chart-container" + chartParameter[targetMapName].div).addClass('d-none')
		}
		var chartOption = {
			div: "covid-town-chart" + chartParameter[targetMapName].div,
			data: [townStackedData.normal],
			key_name: ["point"],
			label: [chartParameter[targetMapName].townChart.seriesName],
			color: [chartParameter[targetMapName].townChart.color],
			stackingType: "normal",
			yAxisLabel: chartParameter[targetMapName].townChart.yAxisLabel,
			legend: false,
			title: chartParameter[targetMapName].townChart.chartTitle,
			click_event_binding: function(trigger_input){
				var query_condition = trigger_input,
					filterGeoJsonByTownRegion = turf.featureCollection([])
				zoomToRegionMap(query_condition)
				filterGeoJson.features.forEach(feature => {
					var thisTownName = condition_area(feature.properties.TID)
					if (thisTownName === query_condition) {
						filterGeoJsonByTownRegion.features.push(feature)
					}
				})
				renderCovidMap(filterGeoJsonByTownRegion, targetMapName)
				renderVillRegionChart(query_condition, filterGeoJsonByTownRegion, targetMapName)
			}
		}
		// 區分疫調案件(追蹤與解除列管)
		if (targetMapName === "infection") {
			townStackedData.infectionSloved = {}
			townStackedData.infectionUnsloved = {}
			filterGeoJson.features.forEach(feature => {
				var thisRegionName = condition_area(feature.properties.TID)
				if (!townStackedData.infectionSloved[thisRegionName]) {
					townStackedData.infectionSloved[thisRegionName] = { point: 0}
					townStackedData.infectionUnsloved[thisRegionName] = { point1: 0}
				}
				if(feature.properties.CaseStatus === "解除列管") {
					townStackedData.infectionSloved[thisRegionName].point += 1
				} else {
					townStackedData.infectionUnsloved[thisRegionName].point1 += 1
				}
			})
			chartOption.data = [townStackedData.infectionSloved, townStackedData.infectionUnsloved]
			chartOption.key_name = ["point", "point1"]
			chartOption.label = [chartParameter[targetMapName].townChart.seriesName + "(解除列管)", chartParameter[targetMapName].townChart.seriesName + "(持續追蹤)"]
			chartOption.color = ["limegreen", chartParameter[targetMapName].townChart.color]
		}
		stacked_chart(chartOption)
		renderCovidMap(filterGeoJson, targetMapName)
		$("#covid-time-range-total-number" + chartParameter[targetMapName].div).html(`
			<div class="card-body text-center">
				${queryDateString}合計${chartParameter[targetMapName].townChart.seriesName}達
				<hr class="m-2">
				<h5 class="font-weight-bold m-0 text-danger">${filterGeoJson.features.length}${chartParameter[targetMapName].townChart.yAxisLabel}</h5>
			</div>`
		)
		// 表單下載(全市)
		$("#covid-alert-table-download-all" + chartParameter[targetMapName].div).off().click(function(){
			var thisDom = $(this),
				param = {
					tid_list: JSON.stringify(targetTownArray),
					m_affect: Number($('input.covid-heart-map-trig[target="covid-weight"]').val()),
					n_footprint: Number($('input.covid-heart-map-trig[target="track-weight"]').val()),
					project_id: covidDeafultKey
				}
			if (timePickSetting[targetMapName]) {
				param.start_time = timePickSetting[targetMapName].min
				param.end_time = timePickSetting[targetMapName].max
			} else {
				var thisDateList = Object.keys(staObject[targetMapName].date)
				param.start_time = thisDateList[0]
				param.end_time = thisDateList[thisDateList.length-1]
			}
			thisDom.attr("disabled", true)
			downloadAlertRegionExcelTable(param, function(){
				thisDom.attr("disabled", false)
			})
		})
	}

	function renderVillRegionChart(targetTownName, targetTownGeoJson, targetMapName){
		var input = {}, thisTownVillGeoJson = ajax_call(publicPath + '/cloud/geoserver/taiwan/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=taiwan%3Avillage_w84&outputFormat=application%2Fjson&cql_filter=COUNTYNAME%20IN%20(%27%E6%96%B0%E5%8C%97%E5%B8%82%27)%20and%20TOWNNAME%20IN%20(%27' + targetTownName + '%27)')
		targetTownGeoJson.features.forEach(feature => {
			var thisVillName = feature.properties.VIL
			if (thisVillName === null) {
				thisVillName = '無資料'
			}
			if (!input[thisVillName]) {
				input[thisVillName] = { point: 0 }
			}
			input[thisVillName].point += 1
		})
		if ($("#covid-village-total-chart-container" + chartParameter[targetMapName].div).hasClass('d-none')) {
			$("#covid-village-total-chart-container" + chartParameter[targetMapName].div).removeClass('d-none')
		}
		var chartOption = {
			div: "covid-village-total-chart" + chartParameter[targetMapName].div,
			data: [input],
			key_name: ["point"],
			label: [chartParameter[targetMapName].villChart.seriesName],
			color: [chartParameter[targetMapName].villChart.color],
			stackingType: "normal",
			yAxisLabel: chartParameter[targetMapName].villChart.yAxisLabel,
			legend: false,
			title: "各村里" + chartParameter[targetMapName].villChart.seriesName + "(" + targetTownName + ")",
			click_event_binding: function(trigger_input){
				var query_condition = trigger_input
				thisTownVillGeoJson.features.forEach(feature => {
					if (query_condition === feature.properties.VILLNAME) {
						var thisLayer = L.geoJson(feature)
						map.fitBounds(thisLayer.getBounds())
					}
				})
			}
		}
		// 區分疫調案件(追蹤與解除列管)
		if (targetMapName === "infection") {
			var villStackedData = {}
			villStackedData.infectionSloved = {}
			villStackedData.infectionUnsloved = {}
			targetTownGeoJson.features.forEach(feature => {
				var thisVillName = feature.properties.VIL
				if (thisVillName === null) {
					thisVillName = '無資料'
				}
				if (!villStackedData.infectionSloved[thisVillName]) {
					villStackedData.infectionSloved[thisVillName] = { point: 0}
					villStackedData.infectionUnsloved[thisVillName] = { point1: 0}
				}
				if(feature.properties.CaseStatus === "解除列管") {
					villStackedData.infectionSloved[thisVillName].point += 1
				} else {
					villStackedData.infectionUnsloved[thisVillName].point1 += 1
				}
			})
			chartOption.data = [villStackedData.infectionSloved, villStackedData.infectionUnsloved]
			chartOption.key_name = ["point", "point1"]
			chartOption.label = [chartParameter[targetMapName].villChart.seriesName + "(解除列管)", chartParameter[targetMapName].villChart.seriesName + "(持續追蹤)"]
			chartOption.color = ["limegreen", chartParameter[targetMapName].villChart.color]
		}
		stacked_chart(chartOption)
		// 表單下載(單區)
		$("#covid-alert-table-download-town" + chartParameter[targetMapName].div).off().click(function(){
			var thisDom = $(this),
				param = {
					tid_list: JSON.stringify([targetTownGeoJson.features[0].properties["TID"]]),
					m_affect: Number($('input.covid-heart-map-trig[target="covid-weight"]').val()),
					n_footprint: Number($('input.covid-heart-map-trig[target="track-weight"]').val()),
					project_id: covidDeafultKey,
					singleRegion: targetTownName
				}
			if (timePickSetting[targetMapName]) {
				param.start_time = timePickSetting[targetMapName].min
				param.end_time = timePickSetting[targetMapName].max
			} else {
				var thisDateList = Object.keys(staObject[targetMapName].date)
				param.start_time = thisDateList[0]
				param.end_time = thisDateList[thisDateList.length-1]
			}
			thisDom.attr("disabled", true)
			downloadAlertRegionExcelTable(param, function(){
				thisDom.attr("disabled", false)
			})
		})
	}

	function renderSpreadChart(targetDayIndex){
		targetDayIndex = parseInt(targetDayIndex)
		var targetCaseInfo = {
				thisDay: staObject.confirmed.case[dateList.confirmed[targetDayIndex]],
				beforeDay: staObject.confirmed.case[dateList.confirmed[targetDayIndex-1]]
			},
			townStackedData = {
				spread: {}
			},
			queryDateString = dateList.confirmed[targetDayIndex].slice(0,4) + "-" + dateList.confirmed[targetDayIndex].slice(4,6) + "-" + dateList.confirmed[targetDayIndex].slice(6,8)
		Object.keys(targetCaseInfo.thisDay.region).forEach(eachRegion => {
			if (targetDayIndex !== 0) {
				if (targetCaseInfo.beforeDay.region[eachRegion] && (targetCaseInfo.thisDay.region[eachRegion] > targetCaseInfo.beforeDay.region[eachRegion])) {
					townStackedData.spread[eachRegion] = { point: parseInt(((targetCaseInfo.thisDay.region[eachRegion]) / targetCaseInfo.beforeDay.region[eachRegion]) * 100) }
				}
			}
		})
		stacked_chart({
			div: "covid-town-spread-chart",
			data: [townStackedData.spread],
			key_name: ["point"],
			label: ["擴散比例"],
			color: ['#e85a71'],
			stackingType: "normal",
			yAxisLabel: "%",
			legend: false,
			title: "各行政區擴散比例(" + queryDateString + ")",
			click_event_binding: function(trigger_input){
				var query_condition = trigger_input
				zoomToRegionMap(query_condition)
			}
		})
	}

	// 示警村里
	$("#covid-alert-village-search").click(function(){
		var param = {
				project_id: covidDeafultKey
			}, 
			sendBool = true, 
			thisSearchBtnDom = $(this)
		$(".covid-alert-village-setting").each(function(){
			var thisValue = $(this).val(), thisKey = $(this).attr('target')
			if (thisKey === "start_time" || thisKey === "end_time") {
				param[thisKey] = thisValue.replaceAll("-", "")
			} else {
				param[thisKey] = Number(thisValue)
				if (isNaN(thisValue)) {
					sendBool = false
				}
				if (thisValue < 0) {
					sendBool = false
				}
			}
		})
		if (sendBool) {
			toast_open("警示區域查詢中，請稍候！")
			thisSearchBtnDom.attr("disabled", true)
			var queryParameterString = ''
			Object.keys(param).forEach(each => {
				if (param[each] !== 0) {
					queryParameterString += each + '=' + param[each] + '&'
				}
			})
			ajax_call_async(publicPath + '/napi/emis/covid_filter?' + queryParameterString, 
				function(alertVillList){
					var html = "", dict = {}, targetTownArray = []
					if (!alertVillList.message) {
						alertVillList.forEach((el, index) => {
							if (!targetTownArray.includes(el.TID)) {
								targetTownArray.push(el.TID)
							}
							var thisTownName = condition_area(el.TID),
								thisVil = el.VIL,
								thisConfirmedNumber = el.vil_count
							if (thisVil === null) {
								thisVil = '無資料'
							}
							if (!dict[thisTownName]) {
								dict[thisTownName] = []
							}
							dict[thisTownName].push(thisVil)
							html += `
								<tr target="${thisTownName}" targetVill="${thisVil}">
									<td>${thisTownName}</td>
									<td>${thisVil}</td>
									<td>${thisConfirmedNumber}例</td>
								</tr>`
						})
						$("#covid-alert-village-search-table-container").html(`
							<table class="table table-sm table-pointer text-center">
								<thead class="thead-dark">
									<tr>
										<th>行政區</th>
										<th>村里名</th>
										<th>確診數</th>
									</tr>
								</thead>
								<tbody>
									${html}
								</tbody>
							</table>
							<button type="button" class="btn btn-success btn-sm btn-block mt-2 mb-2" id="covid-alert-village-table-download">表單下載</button>`
						)
						$("#covid-alert-village-search-table-container table").DataTable({
							"columnDefs": [
								{ type: 'formatted-num', targets: 2 }
							],
							"order": [[ 2, "desc" ]]
						})
						$("#covid-alert-village-search-table-container table").on('click', 'tbody tr', function(){
							if (overlay_dataset["temp_map"]) {
								map.removeLayer(overlay_dataset["temp_map"])
							}
							var targetTown = $(this).attr('target'),
								targetVill = $(this).attr('targetVill'),
								alertVillGeoJson = turf.featureCollection([]),
								thisTownVillGeoJson = ajax_call(publicPath + '/cloud/geoserver/taiwan/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=taiwan%3Avillage_w84&outputFormat=application%2Fjson&cql_filter=COUNTYNAME%20IN%20(%27%E6%96%B0%E5%8C%97%E5%B8%82%27)%20and%20TOWNNAME%20IN%20(%27' + targetTown + '%27)'),
								thisTownLayer = L.geoJson(thisTownVillGeoJson)
							map.fitBounds(thisTownLayer.getBounds())
							thisTownVillGeoJson.features.forEach(feature => {
								if (dict[targetTown].includes(feature.properties.VILLNAME)) {
									alertVillGeoJson.features.push(feature)
								}
							})
							overlay_dataset["temp_map"] = L.geoJson(alertVillGeoJson,{
								style: function (feature){
									if (feature.properties.VILLNAME === targetVill) {
										return {
											fillColor: "red",
											weight: 3,
											color: "black",
											fillOpacity: 0.6
										}
									} else {
										return {
											fillColor: "red",
											weight: 0,
											opacity: 1,
											fillOpacity: 0.6
										}
									}
								},
								onEachFeature: function(feature, layer){
									layer.bindTooltip(feature.properties.TOWNNAME + feature.properties.VILLNAME, {
										opacity: 0.8,
										sticky: true
									})
								}
							}).addTo(map);
							overlay_dataset["確診者點位圖X"].bringToFront()
							overlay_dataset["確診者足跡點位圖Y"].bringToFront()
						})
						$("#covid-alert-village-table-download").click(function(){
							var thisDom = $(this)
							thisDom.attr("disabled", true)
							toast_open("警示區域表單下載中，請稍候！")
							downloadAlertRegionExcelTable({
								tid_list: JSON.stringify(targetTownArray),
								m_affect: Number($('input.covid-heart-map-trig[target="covid-weight"]').val()),
								n_footprint: Number($('input.covid-heart-map-trig[target="track-weight"]').val()),
								start_time: param.start_time,
								end_time: param.end_time,
								project_id: covidDeafultKey
							}, function(){
								thisDom.attr("disabled", false)
							})
						})	
					} else {
						toast_open('通知：' + alertVillList.message)	
					}
					thisSearchBtnDom.attr("disabled", false)
				},
				function(){
					thisSearchBtnDom.attr("disabled", false)
				}
			)
		} else {
			toast_open('您輸入的值必須為「數字」且大等於「0」')
		}
	})

	// excel下載
	function downloadAlertRegionExcelTable(option, callBack){
		var dataObject = {
				tid_list: option.tid_list,
				m_affect: option.m_affect,
				n_footprint: option.n_footprint,
				project_id: option.project_id
			},
			fileName = "全部時段"
		if (option.start_time && option.end_time) {
			dataObject.start_time = option.start_time
			dataObject.end_time = option.end_time
			if (dataObject.start_time === dataObject.end_time) {
				fileName = dataObject.start_time
			} else {
				fileName = dataObject.start_time + "_" + dataObject.end_time
			}
		}
		if (option.singleRegion) {
			fileName = option.singleRegion + fileName
		}
		$.ajax({
			url: publicPath + "/napi/emis/covid_excel",
			xhrFields: {
				responseType: "blob"
			},
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
			},
			type: 'post',
			data: dataObject,
			error: function(e){
				toast_open("API介接資料異常！")
				callBack()
			}
		}).done((data) => {
			var $a = document.createElement("a"), url = URL.createObjectURL(data)
			$a.download = "疫情警示區域表單(" + fileName + ").xlsx"
			$a.href = url
			$a.click()
			if (callBack) {
				callBack()
			}
		})
	}

	// 風險象限圖
	ajax_call_post_async(
		publicPath + "/napi/emis/covid_weekly_risk", 
		{ project_id: covidDeafultKey }, 
		function(data){
			var weekDict = {}, optionHtml = ""
			data.forEach(el => {
				var thisWeekName = el["週次日期"].replace("to", "~")
				if (!weekDict[thisWeekName]) {
					weekDict[thisWeekName] = []	
				}
				el["佔全市比例"] = Number((el["佔全市比例"]*100).toFixed(2))
				el["佔全市比例平均"] = Number((el["佔全市比例平均"]*100).toFixed(2))
				weekDict[thisWeekName].push(el)
			})
			Object.keys(weekDict).reverse().forEach(el => {
				optionHtml += `<option value="${el}">${el}</option>`
			})
			$("#covid-risk-quadrant-week-selector").html(optionHtml)
			$("#covid-risk-quadrant-week-selector").change(function(){
				var value = $(this).val()
				renderQuadrantChart(weekDict[value])
			}).trigger("change")
		},
		function () {}
	)

	function renderQuadrantChart(data){
		var quadrantDict = {
				"1": {
					name: "第一象限",
					color: '#FF2D00',
					data: []
				}, 
				"2": {
					name: "第二象限",
					color: "#FE9090",
					data: []
				}, 
				"3": {
					name: "第三象限",
					color: "#FCD900",
					data: []
				}, 
				"4": {
					name: "第四象限",
					color: "#00CC08",
					data: []
				}, 
				"-": {
					name: "無",
					color: 'grey',
					data: []
				}
			},
			xBaseValue = data[0]["佔全市比例平均"]
		data.forEach(el => {
			quadrantDict[el["本週風險象限"]].data.push({ x: el["佔全市比例"], y: el["slope"], z: el["佔全市比例"], name: el["行政區"].slice(0,2), country: el["行政區"]})
		})
		$("#covid-risk-quadrant-container").html('<div id="covid-risk-quadrant-chart" class="w-100 h-400"></div>')
		Highcharts.chart('covid-risk-quadrant-chart', {
			chart: {
				type: 'bubble',
				plotBorderWidth: 1,
				zoomType: 'xy'
			},
			legend: {
				enabled: true,
				width: '100%',
				padding: 0
			},
			title: {
				text: ''
			},
			xAxis: {
				gridLineWidth: 1,
				title: {
					text: '週確診量佔全市比重'
				},
				labels: {
					format: '{value} %'
				},
				plotLines: [{
					color: 'black',
					dashStyle: 'dot',
					width: 2,
					value: xBaseValue,
					zIndex: 3
				}]
			},
			yAxis: {
				startOnTick: false,
				endOnTick: false,
				title: {
					text: '週成長趨勢'
				},
				labels: {
					format: '{value}'
				},
				maxPadding: 0.2,
				plotLines: [{
					color: 'black',
					dashStyle: 'dot',
					width: 2,
					value: 0,
					zIndex: 3
				}]
			},
			tooltip: {
				useHTML: true,
				headerFormat: '<table>',
				pointFormat: '<tr><th colspan="2"><h6 class="m-0">{point.country}</h6></th></tr>' +
					'<tr><th>週確診量佔全市比重:</th><td>{point.x}%</td></tr>' +
					'<tr><th>週成長趨勢:</th><td>{point.y}</td></tr>',
				footerFormat: '</table>',
				followPointer: true
			},
			plotOptions: {
				series: {
					dataLabels: {
						enabled: true,
						format: '{point.name}'
					}
				}
			},
			series: Object.values(quadrantDict)
		});
	}
}
